// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_qe-8";
export var editMode = "_qe-3";
export var headerRow = "_qe-a";
export var headerTitle = "_qe-b";
export var product = "_qe-1";
export var productDetails = "_qe-5";
export var productDivider = "_qe-7";
export var productImage = "_qe-2";
export var productInfo = "_qe-4";
export var productTitle = "_qe-6";
export var strikethrough = "_qe-9";
export var upsellProductsCard = "_qe-0";